/* tslint:disable */

declare var Object: any;
export interface CommonConfigInterface {
  "iOSEnablePayOnline"?: boolean;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class CommonConfig implements CommonConfigInterface {
  "iOSEnablePayOnline": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: CommonConfigInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CommonConfig`.
   */
  public static getModelName() {
    return "CommonConfig";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CommonConfig for dynamic purposes.
  **/
  public static factory(data: CommonConfigInterface): CommonConfig{
    return new CommonConfig(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CommonConfig',
      plural: 'CommonConfigs',
      path: 'CommonConfigs',
      idName: 'id',
      properties: {
        "iOSEnablePayOnline": {
          name: 'iOSEnablePayOnline',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
